import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { resolveSubjects } from '../../canvas/commands/CommandUtil';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { Marking } from './Marking';

export const marketSetScaledSize = defineCommand(
    'markerSetScaledSize',
    'Marker: Set Scaled Size',
    (r, [scale]: [number]) => {
        const size = 100 * (scale / 10) * (scale / 10);
        r.call(ToolManager).setSetting('markerTool', 'size', size);
        r.call(CommandDispatcher)('toolEquip', ['markerTool']);
    }
);

export const clearMarkings = defineCommand(
    'clearMarkings',
    'Markings: Clear',
    (r, [targetIds]: [string[]?]) => {

        const objects = r.call(ObjectManager);
        const subjects = resolveSubjects(r, targetIds);

        const hits = (subjects.length > 0)
            ? subjects.flatMap(x => x.flatten(true)).filter(x => x.type === 'Marking')
            : objects.getAll(Marking);

        objects.update(u => {
            for (const x of hits) {
                x.removeSelf();
                u.delete(x);
            }
        });
    }
);

export const graffitiClear = defineCommand(
    'graffitiClear',
    'Graffiti: Clear',
    (r, [targetIds]: [string[]?]) => {

        const objects = r.call(ObjectManager);
        const subjects = resolveSubjects(r, targetIds);

        const hits = (subjects.length > 0)
            ? subjects.flatMap(x => x.flatten(true)).filter(x => x.type === 'Marking')
            : objects.getAll(Marking);

        objects.update(u => {
            for (const x of hits) {
                x.removeSelf();
                u.delete(x);
            }
        });
    }
);
